import { useContext, useMemo } from "react";

import { DemoContext } from "contexts/demo";
import { DomainsResponse } from "utils/types/datastores";
import { useAPI } from "hooks/requests/useAPI";
import { needed } from "utils/data/validate";

export const useDomains = () => {
  const { isDemo } = useContext(DemoContext);

  const { data, isLoading, error } = useAPI<DomainsResponse>(`domain`);

  const domainsInfo = useMemo(() => {
    if (isLoading) return {};

    return data;
  }, [data, isDemo, isLoading]);

  return { domainsInfo, isLoading, error };
};
